module.exports = __webpack_public_path__ + "images/emoji/first_quarter_moon_with_face.50d4c3dc23e03d85844a.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/first_quarter_moon_with_face.png
// module id = I493
// module chunks = 14